import { ObjectLayer } from "./object-layer";
import { ObjectType } from "./object-type";
import { ObjectClass } from "./object-class";
import { ObjectStatus } from "./object-status";
import { IDbBaseMetadataValueInfos } from "./i-db-base-metadata-value-infos";
import { SortingInfos, StatusHistoryFilter } from "../../../Redux/Reducers/redux-slice-filters";

export class SearchRequestNative {
  logQuery: boolean = false;
  hideTitleWithoutAsset: boolean | null = null;
  onlyConfidential: boolean | null = null;
  pattern: string | null = null;
  outputLayer: ObjectLayer | null = null;
  titleIds: number[] | null = null;
  parentObjectIds: number[] | null = null;
  assetIds: number[] | null = null;
  titleCustomerIds: string[] | null = null;
  types: ObjectType[] | null = null;
  classifications: ObjectClass[] | null = null;
  statuses: ObjectStatus[] | null = null;
  metadata: IDbBaseMetadataValueInfos[] | null = null;
  createdBy: number[] | null = null;
  providerIds: number[] | null = null;
  limit: number | null = null;
  statusHistory?: StatusHistoryFilter[] | null = null;
  notInAssetIds: number[] | null = null;
  onlyDirectChildren?: boolean | null = null;
  page: number | null = null;
  sort: SortingInfos | null = null;
  skipDeleted: boolean | null = null;
  followerIds?: number[] | null = null;

  constructor(init?: Partial<SearchRequestNative>) {
    Object.assign(this, init);
  }
}
